<div id="wrapper" class="clearfix" [ngClass]="{'main-pages-footer': currentPage !== '/landing'}"  [style]="'padding-bottom: ' + footerHeight + 'px'">
  <ng-content></ng-content>
  <div id="gotoTop" class="icon-angle-up"></div>
</div>
